import { render, staticRenderFns } from "./ListKelompokBarang.vue?vue&type=template&id=73f2c20a&"
import script from "./ListKelompokBarang.vue?vue&type=script&lang=js&"
export * from "./ListKelompokBarang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports